export default __webpack_public_path__ + "static/media/027-skates.5d8ba93c.svg";